// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1K8BJ","header":"ReportDetails_header__2j_s6","title":"ReportDetails_title__1oBH0","left":"ReportDetails_left__2_tx5"};